﻿/*!
    *
    * Wijmo Library 5.20251.34
    * https://developer.mescius.com/wijmo
    *
    * Copyright(c) MESCIUS inc. All rights reserved.
    *
    * Licensed under the End-User License Agreement For MESCIUS Wijmo Software.
    * us.sales@mescius.com
    * https://developer.mescius.com/wijmo/licensing
    *
    */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { VueApi, WjComponentBehavior } from '@mescius/wijmo.vue2.base';
import * as wjcCore from '@mescius/wijmo';
import * as wjcGrid from '@mescius/wijmo.grid';
import * as wjcInteropGrid from '@mescius/wijmo.interop.grid';
/**
 * Represents a cell template types enumeration.
 */
export var CellTemplateType = wjcInteropGrid.GridCellTemplateType;
var WjFlexGridBehavior = /** @class */ (function (_super) {
    __extends(WjFlexGridBehavior, _super);
    function WjFlexGridBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexGridBehavior.prototype._createControl = function () {
        var ret = _super.prototype._createControl.call(this);
        new DirectiveCellFactory(ret);
        return ret;
    };
    WjFlexGridBehavior.tag = 'wj-flex-grid';
    WjFlexGridBehavior.props = [
        'isDisabled',
        'tabOrder',
        'newRowAtTop',
        'allowAddNew',
        'allowDelete',
        'allowDragging',
        'allowMerging',
        'allowResizing',
        'allowSorting',
        'allowPinning',
        'autoScroll',
        'autoRowHeights',
        'autoSizeMode',
        'autoGenerateColumns',
        'autoSearch',
        'caseSensitiveSearch',
        'quickAutoSize',
        'bigCheckboxes',
        'childItemsPath',
        'groupHeaderFormat',
        'headersVisibility',
        'showSelectedHeaders',
        'showMarquee',
        'showPlaceholders',
        'itemFormatter',
        'isReadOnly',
        'imeEnabled',
        'mergeManager',
        'selectionMode',
        'showGroups',
        'showSort',
        'showDropDown',
        'showAlternatingRows',
        'showErrors',
        'alternatingRowStep',
        'itemValidator',
        'validateEdits',
        'treeIndent',
        'itemsSource',
        'autoClipboard',
        'expandSelectionOnCopyPaste',
        'frozenRows',
        'frozenColumns',
        'cloneFrozenCells',
        'deferResizing',
        'sortRowIndex',
        'editColumnIndex',
        'stickyHeaders',
        'preserveSelectedState',
        'preserveOutlineState',
        'preserveWhiteSpace',
        'keyActionTab',
        'keyActionEnter',
        'rowHeaderPath',
        'virtualizationThreshold',
        'anchorCursor',
        'lazyRender',
        'refreshOnEdit',
        'copyHeaders',
        'columnGroups',
        'commitEmptyEdits',
        'headersFocusability',
        'ariaLabel',
        'skipMerged',
        'pasteEmptyCells',
        'groupSummaryPosition',
        'frozenCells',
        'sortOrder',
        'noDataOverlayContent'
    ];
    WjFlexGridBehavior.events = [
        'initialized',
        'gotFocus',
        'lostFocus',
        'refreshing',
        'refreshed',
        'invalidInput',
        'beginningEdit',
        'cellEditEnded',
        'cellEditEnding',
        'prepareCellForEdit',
        'formatItem',
        'resizingColumn',
        'resizedColumn',
        'autoSizingColumn',
        'autoSizedColumn',
        'draggingColumn',
        'draggingColumnOver',
        'draggedColumn',
        'sortingColumn',
        'sortedColumn',
        'pinningColumn',
        'pinnedColumn',
        'resizingRow',
        'resizedRow',
        'autoSizingRow',
        'autoSizedRow',
        'draggingRow',
        'draggingRowOver',
        'draggedRow',
        'deletingRow',
        'deletedRow',
        'loadingRows',
        'loadedRows',
        'rowEditStarting',
        'rowEditStarted',
        'rowEditEnding',
        'rowEditEnded',
        'rowAdded',
        'groupCollapsedChanging',
        'groupCollapsedChanged',
        'columnGroupCollapsedChanging',
        'columnGroupCollapsedChanged',
        'itemsSourceChanging',
        'itemsSourceChanged',
        'selectionChanging',
        'selectionChanged',
        'scrollPositionChanged',
        'updatingView',
        'updatedView',
        'updatingLayout',
        'updatedLayout',
        'pasting',
        'pasted',
        'pastingCell',
        'pastedCell',
        'copying',
        'copied'
    ];
    WjFlexGridBehavior.classCtor = function () { return wjcGrid.FlexGrid; };
    return WjFlexGridBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.FlexGrid} control.
 *
 * The <b>wj-flex-grid</b> component may contain
 * the following child components:
 * {@link wijmo.vue2.grid.detail.WjFlexGridDetail}
 * , {@link wijmo.vue2.grid.filter.WjFlexGridFilter}
 * , {@link wijmo.vue2.grid.WjFlexGridColumn}
 * , {@link wijmo.vue2.grid.WjFlexGridColumnGroup}
 * and {@link wijmo.vue2.grid.WjFlexGridCellTemplate}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.FlexGrid} control it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 *
 * The example below shows how to instantiate and initialize a
 * {@link wijmo.grid.FlexGrid} control using Vue markup:
 *
 * <pre>&lt;wj-flex-grid
 *   :items-source="data"&gt;
 *   &lt;wj-flex-grid-column binding="name" header="Name"&gt;
 *   &lt;/wj-flex-grid-column&gt;
 *   &lt;wj-flex-grid-column binding="sales" header="Sales" format="c0"&gt;
 *   &lt;/wj-flex-grid-column&gt;
 *   &lt;wj-flex-grid-column binding="expenses" header="Expenses" format="c0"&gt;
 *   &lt;/wj-flex-grid-column&gt;
 *   &lt;wj-flex-grid-column binding="active" header="Active"&gt;
 *   &lt;/wj-flex-grid-column&gt;
 *   &lt;wj-flex-grid-column binding="date" header="Date"&gt;
 *   &lt;/wj-flex-grid-column&gt;
 * &lt;/wj-flex-grid&gt;</pre>
 *
 * The code sets the <b>itemsSource</b> property to a collection that contains the grid
 * data, then specifies the columns to display using <b>wj-flex-grid-column</b>
 * components.
 */
export var WjFlexGrid = WjFlexGridBehavior.register();
function registerV3WjFlexGrid(app) {
    app.component(WjFlexGridBehavior.tag, WjFlexGrid);
}
var WjFlexGridColumnBehavior = /** @class */ (function (_super) {
    __extends(WjFlexGridColumnBehavior, _super);
    function WjFlexGridColumnBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexGridColumnBehavior.prototype._initParent = function () {
        var grid = this.parent.control;
        if (grid.autoGenerateColumns) {
            grid.autoGenerateColumns = false;
            grid.columns.clear();
        }
        _super.prototype._initParent.call(this);
    };
    WjFlexGridColumnBehavior.tag = 'wj-flex-grid-column';
    WjFlexGridColumnBehavior.parentProp = 'columns';
    WjFlexGridColumnBehavior.props = [
        'wjProperty',
        'name',
        'dataMap',
        'dataType',
        'binding',
        'sortMemberPath',
        'format',
        'cellTemplate',
        'header',
        'width',
        'maxLength',
        'minWidth',
        'maxWidth',
        'align',
        'allowDragging',
        'allowSorting',
        'allowResizing',
        'allowMerging',
        'aggregate',
        'isReadOnly',
        'cssClass',
        'cssClassAll',
        'isContentHtml',
        'isSelected',
        'visible',
        'wordWrap',
        'multiLine',
        'mask',
        'inputType',
        'isRequired',
        'showDropDown',
        'dataMapEditor',
        'dropDownCssClass',
        'quickAutoSize',
        'editor',
        'placeholder',
        'sortOrder'
    ];
    WjFlexGridColumnBehavior.events = [
        'initialized'
    ];
    WjFlexGridColumnBehavior.changeEvents = {
        'grid.selectionChanged': ['isSelected'],
    };
    WjFlexGridColumnBehavior.classCtor = function () { return wjcGrid.Column; };
    return WjFlexGridColumnBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.Column} class.
 *
 * The <b>wj-flex-grid-column</b> component should be contained in
 * a {@link wijmo.vue2.grid.WjFlexGrid} component.
 *
 * The <b>wj-flex-grid-column</b> component may contain
 * a {@link wijmo.vue2.grid.WjFlexGridCellTemplate} child component.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.Column} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexGridColumn = WjFlexGridColumnBehavior.register();
function registerV3WjFlexGridColumn(app) {
    app.component(WjFlexGridColumnBehavior.tag, WjFlexGridColumn);
}
var WjFlexGridColumnGroupBehavior = /** @class */ (function (_super) {
    __extends(WjFlexGridColumnGroupBehavior, _super);
    function WjFlexGridColumnGroupBehavior() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WjFlexGridColumnGroupBehavior.tag = 'wj-flex-grid-column-group';
    WjFlexGridColumnGroupBehavior.parentProp = 'columnGroups';
    WjFlexGridColumnGroupBehavior.props = [
        'wjProperty',
        'name',
        'dataMap',
        'dataType',
        'binding',
        'sortMemberPath',
        'format',
        'cellTemplate',
        'header',
        'width',
        'maxLength',
        'minWidth',
        'maxWidth',
        'align',
        'allowDragging',
        'allowSorting',
        'allowResizing',
        'allowMerging',
        'aggregate',
        'isReadOnly',
        'cssClass',
        'cssClassAll',
        'isContentHtml',
        'isSelected',
        'visible',
        'wordWrap',
        'multiLine',
        'mask',
        'inputType',
        'isRequired',
        'showDropDown',
        'dataMapEditor',
        'dropDownCssClass',
        'quickAutoSize',
        'editor',
        'placeholder',
        'collapseTo',
        'isCollapsed',
        'height',
        'sortOrder'
    ];
    WjFlexGridColumnGroupBehavior.events = [
        'initialized'
    ];
    WjFlexGridColumnGroupBehavior.changeEvents = {
        'grid.selectionChanged': ['isSelected'],
    };
    WjFlexGridColumnGroupBehavior.classCtor = function () { return wjcGrid.ColumnGroup; };
    return WjFlexGridColumnGroupBehavior;
}(WjComponentBehavior));
/**
 * Vue component for the {@link wijmo.grid.ColumnGroup} class.
 *
 * The <b>wj-flex-grid-column-group</b> component should be contained in
 * one of the following components:
 * {@link wijmo.vue2.grid.WjFlexGrid}
 *  or {@link wijmo.vue2.grid.WjFlexGridColumnGroup}.
 *
 * The <b>wj-flex-grid-column-group</b> component may contain
 * the following child components:
 * {@link wijmo.vue2.grid.WjFlexGridColumnGroup}
 * and {@link wijmo.vue2.grid.WjFlexGridCellTemplate}.
 *
 * The component supports all properties and events of the pure JavaScript {@link wijmo.grid.ColumnGroup} class it represents.
 *
 * The component includes an <b>initialized</b> event that is raised when the control is initialized after it is added to the page.
 * You can use this event to perform further initialization in addition to setting properties in markup.
 * The signature of the handler function is the same as any other Wijmo event handlers.
 */
export var WjFlexGridColumnGroup = WjFlexGridColumnGroupBehavior.register();
function registerV3WjFlexGridColumnGroup(app) {
    app.component(WjFlexGridColumnGroupBehavior.tag, WjFlexGridColumnGroup);
}
var DirectiveCellFactory = /** @class */ (function (_super) {
    __extends(DirectiveCellFactory, _super);
    function DirectiveCellFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    // Overrides
    DirectiveCellFactory.prototype.shouldInstantiate = function (cellInfo) {
        var templateCache = cellInfo.templateCache, isForeignCell = templateCache == null || templateCache.column !== cellInfo.column ||
            !templateCache.cellCmp ||
            templateCache.templateContextProperty !== cellInfo.templateContextProperty ||
            cellInfo.cell.firstChild != templateCache.rootElement;
        return isForeignCell;
    };
    DirectiveCellFactory.prototype.renderTemplate = function (cellInfo, initNew) {
        var row = cellInfo.row, 
        //dataContext = initNew ? {} : cellInfo.templateCache.viewRef.context,
        dataContext = {}, templateContext = cellInfo.templateContext;
        cellInfo.cellBindingsData = this.setBindingsData(dataContext, row, cellInfo.column, row.dataItem, cellInfo.cellValue, templateContext.valuePaths);
        cellInfo.cellBindingsData.localVars.valueFormatted = cellInfo.cellValueFormatted;
        if (initNew) {
            var cell = cellInfo.cell;
            var templInstance = templateContext._instantiateTemplate(cell, dataContext.cell);
            var templateCache = cellInfo.templateCache = {
                column: cellInfo.column,
                rootElement: templInstance.$el,
                templateContextProperty: cellInfo.templateContextProperty,
                cellCmp: templInstance
            };
            cell[cellInfo.templateContextProperty] = templateCache;
        }
        else {
            var cellCmp = cellInfo.templateCache.cellCmp;
            cellCmp.context = dataContext.cell;
            cellCmp.$forceUpdate();
        }
    };
    DirectiveCellFactory.prototype.disposeTemplate = function (cell, templateCache, templateContext) {
        var cellCmp = templateCache && templateCache.cellCmp;
        if (cellCmp) {
            cellCmp.$destroy();
            templateCache.cellCmp = null;
            _super.prototype.disposeTemplate.call(this, cell, templateCache, templateContext);
        }
    };
    DirectiveCellFactory.prototype.clearCell = function (cell) {
        cell.textContent = '';
    };
    DirectiveCellFactory.prototype.applyImmediately = function (cellInfo) {
        if (!VueApi.isV3Plus) {
            // refresh cells immediately on measuring (WJM-22848) (Vue3 have no such an issue)
            var watcher = cellInfo.templateCache.cellCmp._watcher;
            if (watcher && (typeof watcher.run === 'function')) {
                watcher.run();
            }
        }
    };
    DirectiveCellFactory.prototype.flushPendingEvents = function (control) {
        // do nothing
    };
    // TBD: patch
    DirectiveCellFactory.prototype.getEditorFocusFlag = function () {
        //return this.grid._edtFocus;
        return true;
    };
    DirectiveCellFactory.prototype.setEditorFocusFlag = function (value) {
        //this.grid._edtFocus = value;
    };
    return DirectiveCellFactory;
}(wjcInteropGrid.DirectiveCellFactoryBase));
export { DirectiveCellFactory };
export var WjFlexGridCellTemplateDefinition = {
    props: {
        cellOverflow: { default: undefined },
        cellType: { default: undefined },
        autoSizeRows: { default: true },
        forceFullEdit: { default: true }
    },
    render: function (createElement) {
        return VueApi.isV3Plus
            ? VueApi.h('div')
            : createElement('div');
    },
    mounted: function () {
        var _this = this;
        var parCmp = this.$parent;
        if (parCmp) {
            var parentBeh_1 = parCmp[WjComponentBehavior._behProp];
            parentBeh_1._mountedCB(function () {
                var ownerControl = _this.ownerControl = parentBeh_1.control;
                if (ownerControl instanceof wjcGrid.FlexGrid) {
                    _this.grid = ownerControl;
                }
                else if (ownerControl instanceof wjcGrid.Column) {
                    _this.column = ownerControl;
                    var par2Cmp = parCmp, grid = void 0;
                    do {
                        par2Cmp = par2Cmp.$parent;
                        var par2Beh = par2Cmp && par2Cmp[WjComponentBehavior._behProp];
                        grid = par2Beh && par2Beh.control;
                    } while (!(grid instanceof wjcGrid.FlexGrid));
                    _this.grid = grid;
                }
                _this._attachToControl();
            });
        }
    },
    methods: {
        _attachToControl: function () {
            var cellType = this.cellTypeEnum = wjcCore.asEnum(this.cellType, CellTemplateType), ownerControl = this.ownerControl;
            ownerControl[DirectiveCellFactory.getTemplContextProp(cellType)] =
                this;
            // TBD: remove flag on dispose if possible
            if (ownerControl instanceof wjcGrid.Column &&
                (cellType === CellTemplateType.Cell ||
                    cellType === CellTemplateType.ColumnHeader ||
                    cellType === CellTemplateType.ColumnFooter)) {
                ownerControl._setFlag(wjcGrid.RowColFlags.HasTemplate, true);
            }
            this.grid.invalidate();
        },
        _detachFromControl: function () {
            if (this.cellTypeEnum != null) {
                this.ownerControl[DirectiveCellFactory.getTemplContextProp(this.cellTypeEnum)] = null;
                this.grid.invalidate();
            }
        },
        _instantiateTemplate: function (parent, dataContext) {
            var ret = VueApi.isV3Plus
                ? (new V3CellTemplateCmp({ parent: this }))
                : (new CellTemplateCmp({ parent: this }));
            ret.context = dataContext;
            ret.slotFn = VueApi.isV3Plus
                ? this.$slots.default
                : this.$scopedSlots.default;
            // Mount as detached component
            ret.$mount();
            if (parent) {
                parent.appendChild(ret.$el);
            }
            return ret;
        }
    }
};
WjFlexGridCellTemplateDefinition[VueApi.isV3Plus ? 'unmounted' : 'destroyed'] = function () {
    this._detachFromControl();
};
var WjFlexGridCellTemplateTag = 'wj-flex-grid-cell-template';
/**
* Vue component for the {@link FlexGrid} cell templates.
*
* The <b>wj-flex-grid-cell-template</b> component defines a template for a certain
* cell type in {@link FlexGrid}. The template element must contain a <b>cellType</b> attribute that
* specifies the {@link wijmo.vue2.grid.CellTemplateType}. Depending on the template's cell type,
* the <b>wj-flex-grid-cell-template</b> element must be a child
* of either {@link wijmo.vue2.grid.WjFlexGrid}
* or {@link wijmo.vue2.grid.WjFlexGridColumn} components.
*
* Column-specific cell templates must be contained in <b>wj-flex-grid-column</b>
* components, and cells that are not column-specific (like row header or top left cells)
* must be contained in the <b>wj-flex-grid</b> component.
*
* The <b>wj-flex-grid-cell-template</b> element
* may contain an arbitrary HTML fragment with Vue interpolation expressions and
* other components and directives.
*
* Bindings in HTML fragment can use scoped slot properties that store cell specific data.
* The properties are <b>col</b>, <b>row</b>, and <b>item</b>, which refer to the {@link Column},
* {@link Row}, and <b>Row.dataItem</b> objects pertaining to the cell.
*
* For cell types like <b>Group</b> and <b>CellEdit</b>, an additional <b>value</b>
* property containing an unformatted cell value is provided.
*
* To reference slot properties, you can use either a new v-slot directive right on the
* <b>wj-flex-grid-cell-template</b> element (it's available in Vue 2.6.0 or higher),
* or an old slot-scope directive on the <b>&lt;template&gt;</b> element nested in
* wj-flex-grid-cell-template.
*
* For example, here is a
* {@link FlexGrid} control with templates for row header cells and, regular
* and column header cells of the Country column:
*
* ```html
* <!-- component.html -->
* <wj-flex-grid :itemsSource="data">
*   <wj-flex-grid-cell-template cellType="RowHeader" v-slot="cell">
*     {{cell.row.index}}
*   </wj-flex-grid-cell-template>
*   <wj-flex-grid-cell-template cellType="RowHeaderEdit">
*     ...
*   </wj-flex-grid-cell-template>
*
*   <wj-flex-grid-column header="Country" binding="country">
*     <wj-flex-grid-cell-template cellType="ColumnHeader" v-slot="cell">
*       <img src="resources/globe.png" />
*         {{cell.col.header}}
*     </wj-flex-grid-cell-template>
*     <wj-flex-grid-cell-template cellType="Cell" v-slot="cell">
*       <img :src="'resources/' + cell.item.country + '.png'" />
*       {{cell.item.country}}
*     </wj-flex-grid-cell-template>
*   </wj-flex-grid-column>
*   <wj-flex-grid-column header="Sales" binding="sales"></wj-flex-grid-column>
* </wj-flex-grid>
* ```
*
* The <b>wj-flex-grid-cell-template</b> directive supports the following attributes:
*
* <dl class="dl-horizontal">
*   <dt>cellType</dt>
*   <dd>
*     The <b>CellTemplateType</b> value defining the type of cell to which the template is applied.
*   </dd>
*   <dt>autoSizeRows</dt>
*   <dd>
*     Indicates whether the cell template will increase grid's default row height
*     to accomodate cells content. Defaults to true.
*   </dd>
*   <dt>cellOverflow</dt>
*   <dd>
*     Defines the <b>style.overflow</b> property value for cells.
*   </dd>
*   <dt>forceFullEdit</dt>
*   <dd>
*     For cell edit templates, indicates whether cell editing forcibly starts in full edit mode,
*     regardless of how the editing was initiated. In full edit mode pressing cursor keys don't finish editing.
*     Defaults to true.
*   </dd>
* </dl>
*
* The <b>cellType</b> attribute takes any of the following enumerated values:
*
* <b>Cell</b>
*
* Defines a regular (data) cell template. Must be a child of the {@link wijmo.vue2.grid.WjFlexGridColumn} component.
* For example, this cell template shows flags in the cells of Country column:
*
* ```html
* <wj-flex-grid-column header="Country" binding="country">
*   <wj-flex-grid-cell-template cellType="Cell" v-slot="cell">
*     <img :src="'resources/' + cell.item.country + '.png'" />
*     {{cell.item.country}}
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*
* If <b>Group</b> template is not provided for a hierarchical {@link FlexGrid} (that is, one with the <b>childItemsPath</b> property
* specified), non-header cells in group rows of
* this {@link Column} also use this template.
*
* <b>CellEdit</b>
*
* Defines a template for a cell in edit mode. Must be a child of the {@link wijmo.vue2.grid.WjFlexGridColumn} component.
* This cell type has an additional <b>value</b> scoped slot property available for binding. It contains the
* original cell value before editing, and the updated value after editing.
*
* For example, here is a template that uses the Wijmo {@link InputNumber} control as an editor
* for the "Sales" column:
* ```html
* <wj-flex-grid-column header="Sales" binding="sales">
*   <wj-flex-grid-cell-template cellType="CellEdit">
*     <wj-input-number v-model="cell.value" :step="1"></wj-input-number>
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*
* Note that two-way binding can also be specified using the binding's <b>sync</b> modifier:
* ```html
* <wj-flex-grid-column header="Sales" binding="sales">
*   <wj-flex-grid-cell-template cellType="CellEdit">
*     <wj-input-number value.sync="cell.value" :step="1"></wj-input-number>
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*
* <b>ColumnHeader</b>
*
* Defines a template for a column header cell. Must be a child of the {@link wijmo.vue2.grid.WjFlexGridColumn} component.
* For example, this template adds an image to the header of the "Country" column:
*
* ```html
* <wj-flex-grid-column header="Country" binding="country">
*   <wj-flex-grid-cell-template cellType="ColumnHeader" v-slot="cell">
*     <img src="resources/globe.png" />
*     {{cell.col.header}}
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*
* <b>RowHeader</b>
*
* Defines a template for a row header cell. Must be a child of the {@link wijmo.vue2.grid.WjFlexGrid} component.
* For example, this template shows row indices in the row headers:
*
* ```html
* <wj-flex-grid :itemsSource="data">
*   <wj-flex-grid-cell-template cellType="RowHeader" v-slot="cell">
*     {{cell.row.index + 1}}
*   </wj-flex-grid-cell-template>
* </wj-flex-grid>
* ```
*
* Note that this template is applied to a row header cell, even if it is in a row that is
* in edit mode. In order to provide an edit-mode version of a row header cell with alternate
* content, define the <b>RowHeaderEdit</b> template.
*
* <b>RowHeaderEdit</b>
*
* Defines a template for a row header cell in edit mode. Must be a child of the
* {@link wijmo.vue2.grid.WjFlexGrid} component. For example, this template shows dots in the header
* of rows being edited:
*
* ```html
* <wj-flex-grid :itemsSource="data">
*   <wj-flex-grid-cell-template cellType="RowHeaderEdit">
*     ...
*   </wj-flex-grid-cell-template>
* </wj-flex-grid>
* ```
*
* Use the following <b>RowHeaderEdit</b> template to add the standard edit-mode indicator to cells where the <b>RowHeader</b> template
* applies:
*
* ```html
* <wj-flex-grid :itemsSource="data">
*   <wj-flex-grid-cell-template cellType="RowHeaderEdit">
*     &#x270e;&#xfe0e;
*   </wj-flex-grid-cell-template>
* </wj-flex-grid>
* ```
*
* <b>TopLeft</b>
*
* Defines a template for the top left cell. Must be a child of the {@link wijmo.vue2.grid.WjFlexGrid} component.
* For example, this template shows a down/right glyph in the top-left cell of the grid:
*
* ```html
* <wj-flex-grid :itemsSource="data">
*   <wj-flex-grid-cell-template cellType="TopLeft">
*     <span class="wj-glyph-down-right"></span>
*   </wj-flex-grid-cell-template>
* </wj-flex-grid>
* ```
*
* <b>GroupHeader</b>
*
* Defines a template for a group header cell in a {@link GroupRow}. Must be a child of the {@link wijmo.vue2.grid.WjFlexGridColumn} component.
*
* The <b>row</b> scoped slot property contains an instance of the <b>GroupRow</b> class. If the grouping comes
* from {@link CollectionView}, the <b>item</b> scoped slot property references the {@link CollectionViewGroup} object.
*
* For example, this template uses a checkbox element as an expand/collapse toggle:
*
* ```html
* <wj-flex-grid-column header="Country" binding="country">
*   <wj-flex-grid-cell-template cellType="GroupHeader" v-slot="cell">
*     <input type="checkbox" v-model="cell.row.isCollapsed"/>
*     {{cell.item.name}} ({{cell.item.items.length}} items)
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*
* <b>Group</b>
*
* Defines a template for a regular cell (not a group header) in a {@link GroupRow}. Must be a child of the
* {@link wijmo.vue2.grid.WjFlexGridColumn} component. This cell type has an additional <b>value</b> scoped
* slot property available for
* binding. In cases where columns have the <b>aggregate</b> property specified, it contains the unformatted
* aggregate value.
*
* For example, this template shows aggregate's value and kind for group row cells in the "Sales"
* column:
*
* ```html
* <wj-flex-grid-column header="Sales" binding="sales" aggregate="Avg">
*   <wj-flex-grid-cell-template cellType="Group" v-slot="cell">
*     Average: {{formatNumber(cell.value, 'N0')}}
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*
* <b>ColumnFooter</b>
*
* Defines a template for a regular cell in a <b>columnFooters</b> panel. Must be a child of the
* {@link wijmo.vue2.grid.WjFlexGridColumn} component. This cell type has an additional <b>value</b>
* scoped slot property available for binding that contains a cell value.
*
* For example, this template shows aggregate's value and kind for a footer cell in the "Sales"
* column:
*
* ```html
* <wj-flex-grid-column header="Sales" binding="sales" aggregate="Avg">
*   <wj-flex-grid-cell-template cellType="ColumnFooter" v-slot="cell">
*     Average: {{formatNumber(cell.value, 'N0')}}
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*
* <b>BottomLeft</b>
*
* Defines a template for the bottom left cells (at the intersection of the row header and column footer cells).
* Must be a child of the {@link wijmo.vue2.grid.WjFlexGrid} component.
* For example, this template shows a sigma glyph in the bottom-left cell of the grid:
*
* ```html
* <wj-flex-grid :itemsSource="data">
*   <wj-flex-grid-cell-template cellType="BottomLeft">
*     &#931;
*   </wj-flex-grid-cell-template>
* </wj-flex-grid>
* ```
*
* <b>NewCellTemplate</b>
*
* Defines a cell in a new row template. Must be a child of the {@link wijmo.vue2.grid.WjFlexGridColumn} component.
* Note that the <b>cell.item</b> property is undefined for this type of a cell.
* For example, this cell template shows a placeholder in the Date column's cell in the "new row" item:
*
* ```html
* <wj-flex-grid-column header="'Date'" binding="'date'">
*   <wj-flex-grid-cell-template cellType="NewCellTemplate">
*     Enter a date here
*   </wj-flex-grid-cell-template>
* </wj-flex-grid-column>
* ```
*/
export var WjFlexGridCellTemplate = VueApi.isV3Plus
    ? WjFlexGridCellTemplateDefinition
    : VueApi.component(WjFlexGridCellTemplateTag, WjFlexGridCellTemplateDefinition);
function registerV3WjFlexGridCellTemplate(app) {
    app.component(WjFlexGridCellTemplateTag, WjFlexGridCellTemplate);
}
var CellTemplateCmp = VueApi.extend({
    render: function (createElement) {
        var slotFn = this.slotFn;
        return createElement('div', slotFn && [slotFn(this.context)]);
    }
});
var V3CellTemplateCmp = /** @class */ (function () {
    function V3CellTemplateCmp(props) {
        this.props = props;
        this._host = document.createElement('div');
    }
    V3CellTemplateCmp.prototype.$mount = function () {
        var _this = this;
        var h = VueApi.h;
        var _a = this.props, parent = _a.parent, props = __rest(_a, ["parent"]);
        var render = function () { return h('div', props, _this.slotFn && _this.slotFn(_this.context)); };
        VueApi.render(h({ parent: parent, render: render }), this.$el);
    };
    Object.defineProperty(V3CellTemplateCmp.prototype, "$el", {
        get: function () {
            return this._host;
        },
        enumerable: true,
        configurable: true
    });
    V3CellTemplateCmp.prototype.$destroy = function () {
        VueApi.render(null, this.$el);
        this._host = null;
    };
    V3CellTemplateCmp.prototype.$forceUpdate = function () {
        this._host && this.$mount();
    };
    return V3CellTemplateCmp;
}());
export function registerGrid(app) {
    if (VueApi.isV3Plus) {
        registerV3WjFlexGrid(app);
        registerV3WjFlexGridColumn(app);
        registerV3WjFlexGridColumnGroup(app);
        registerV3WjFlexGridCellTemplate(app);
    }
}
